import { render } from "./TrekCreateView.vue?vue&type=template&id=6ece63b0&scoped=true"
import script from "./TrekCreateView.vue?vue&type=script&lang=js"
export * from "./TrekCreateView.vue?vue&type=script&lang=js"

import "./TrekCreateView.vue?vue&type=style&index=0&id=6ece63b0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ece63b0"]])

export default __exports__